import _ from 'lodash'
import type { BaseDataItem } from '@wix/thunderbolt-becky-types'
import type { Ref } from '@wix/materializer'
import { seoMergeBlob } from '@wix/thunderbolt-becky-root'
import { RESOLVED_TRANSLATIONS_ASPECT } from '../../constants'
import { createTemplateDataNode } from './utils/dataNodeUtils'
import type { DataNodeData } from './types'

type Dependencies = {
	[translation: string]: Ref<BaseDataItem>
}

export const DocumentData = createTemplateDataNode<BaseDataItem, Dependencies, DataNodeData<Dependencies>>({
	getDependencies: ({ id }, scopedCreateRef) => ({
		translation: scopedCreateRef(RESOLVED_TRANSLATIONS_ASPECT, id),
	}),
	// translation logic ported from here:
	// https://github.com/wix-private/thunderbolt/blob/c2477ae15103f43e39f53c2e25911b556f584b1b/packages/thunderbolt-becky/src/carmi/translateData.carmi.ts
	toViewItem: ({ rawItem, value }) => {
		const { custom } = value || {}

		if (custom.translation) {
			const translatedDataItem = custom.translation

			if (rawItem.type !== translatedDataItem.type) {
				return rawItem
			}

			switch (rawItem.type) {
				case 'Repeater':
					return rawItem
				case 'Page':
					// @ts-ignore known type issue: https://github.com/wix-private/thunderbolt/blob/ddcc666419338148ea41b86fe21b0f592c1a35bf/packages/thunderbolt-becky-root/src/types/becky.ts#L186
					return seoMergeBlob(rawItem, {
						...translatedDataItem,
						..._.pick(rawItem, [
							'type', // https://wix.slack.com/archives/CAKBA7TDH/p1612266650077500
							'tpaApplicationId', // https://wix.slack.com/archives/CAKBA7TDH/p1612266650077500
							'pageUriSEO', // TB-2238
							'pageSecurity', // TB-3678
						]),
					})
				case 'Anchor':
					return {
						...translatedDataItem,
						..._.pick(rawItem, [
							'compId', // TB-2868
						]),
					}
				default:
					return translatedDataItem
			}
		}

		return rawItem
	},
})
